import React from 'react';
import styled from 'styled-components';
import { lightGrey1Color, busyBackground, lightGrey2Color } from 'js/config/style';

export default styled(({ isBusy, disabled, color, ...props }) => <div {...props} />)`
  width: 200px;
  line-height: 2.2rem;
  user-select: none;
  color: ${({ disabled, color }) => (disabled ? lightGrey2Color : color || 'black')};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  ${({ isBusy }) => isBusy && busyBackground()}
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    background: ${lightGrey1Color};
  }

  &:active {
    background: ${lightGrey1Color.darken(0.5)};
  }
`;
